import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const LogoutIcon = ({
  width = 12,
  marginLeft,
  color = 'black',
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 15">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M6.802 1c1.787 0 3.478.692 4.76 1.949.416.408.422 1.076.013 1.492-.407.416-1.075.42-1.49.015-.887-.87-2.052-1.347-3.283-1.347-2.588 0-4.693 2.106-4.693 4.694 0 2.587 2.105 4.693 4.693 4.693 1.231 0 2.397-.478 3.282-1.346.414-.41 1.084-.403 1.491.014.41.416.403 1.084-.013 1.492-1.28 1.257-2.973 1.949-4.76 1.949C3.052 14.605 0 11.554 0 7.803 0 4.052 3.052 1 6.802 1zM5.487 5.204c.293-.17.648-.173.944 0l3.086 1.78c.296.171.473.478.473.82 0 .34-.177.646-.473.816l-3.085 1.781c-.148.086-.31.128-.473.128-.163 0-.324-.043-.472-.128-.296-.17-.472-.476-.472-.818V6.021c0-.34.176-.647.472-.817z"
      />
    </svg>
  </DefaultIconWrapper>
);
